<template>
  <v-container class="playlist-item" :class="statusClass">
    <div style="display:flex;flex-direction:row;justify-content:space-between;height:100%;">
      <div v-if="media.playlistOrder" class="py-2 custom-center" style="width:42px;display:flex;flex-direction:column;justify-content:space-between;">
        <v-btn :disabled="media.playlistOrder<=1" icon @click="changeOrder(true)"><v-icon large>mdi-chevron-up</v-icon></v-btn>
          <span class="font-weight-bold headline"><slot name="position"></slot></span>
        <v-btn :disabled="media.playlistOrder>=media.playlistLength" icon @click="changeOrder(false)"><v-icon large>mdi-chevron-down</v-icon></v-btn>
      </div>
       <div v-if="!media.playlistOrder" class="py-2 custom-center" style="width:42px;display:flex;flex-direction:column;justify-content:space-between;">
      </div>
      <div class="image_bloc ml-4" :class="screentype" style="display:flex;padding-top:0!important;">
        <v-img :src="thumbnailPath" @load="displayMedia" :class="loading === true? 'loading': ''" class="photo">
        </v-img>
        <div class="status">
          <v-icon style="position:absolute;left:10px;bottom:7px;color:white;">{{ statusIcon }}</v-icon>
          <div class="status_title"> {{ status }} </div>
          <div style="position:absolute;right:0px;bottom:0px;height:30px;width:34px;background-color:#252735;border-radius:6px 0px 0px 0px;">
            <v-icon style="position:absolute;right:5px;bottom:3px;color:white;">mdi-image-size-select-actual</v-icon>
          </div>
        </div>
      </div>
      <div class="text_bloc d-inline-flex align-start flex-column" style="flex-grow:1;overflow-x:hidden;overflow-y:auto;">
        <div class="photo_name mb-1">
          {{ media.titre }}
        </div>
        <span class="photo_details" v-html="broadcastDates"></span>
        <span class="photo_details" v-html="broadcastHours"></span>
        <div class="flex-row mt-auto mb-4">
          <v-chip v-if="broadcastDuration!==''" class="photo_details" outlined v-html="broadcastDuration"></v-chip>
          <v-chip class="photo_details" outlined v-html="broadcastDays"></v-chip>
        </div>
      </div>
      <div class="photo_details" style="display:flex;flex-grow:0;overflow-x:hidden;overflow-y:auto;width:200px!important;">
        <p class="pa-0 mx-auto my-auto text-center" v-html="broadcastScreens"></p>
      </div>
      <v-col class="mt-1 px-5 d-inline-flex flex-row flex-wrap justify-space-between flex-grow-0" style="min-width:400px!important;max-width:400px!important;width:400px!important;"><!--quand il y aura les 6 boutons mettre: min-width:560px-->
        <div @click="suspendMedia" v-if="!suspendable">  
          <SlideButton class="large-btn shadow suspendMedia" v-bind:width="buttonBlockWidth" >
            <template v-slot:icon>
              mdi-pause
            </template>
            <template v-slot:text>
              Suspendre<br>
              le média
            </template>
          </SlideButton>
        </div>
        <div @click="startBroadcast" v-if="suspendable">  
          <SlideButton class="large-btn shadow startBroadcast" v-bind:width="buttonBlockWidth" >
            <template v-slot:icon>
              mdi-play
            </template>
            <template v-slot:text>
              Commencer<br>
              la diffusion
            </template>
          </SlideButton>
        </div>
        <div ><!-- @click="editMedia" -->
          <SlideButton disabled="true" class="large-btn shadow editMedia" v-bind:width="buttonBlockWidth">
            <template v-slot:icon>
              mdi-pencil
            </template>
            <template v-slot:text>
              Modifier<br>
              le média
            </template>
          </SlideButton>
        </div>
<!--         <div>
          <SlideButton class="large-btn shadow editScreens" v-bind:width="buttonBlockWidth" >
            <template v-slot:icon>
              mdi-monitor
            </template>
            <template v-slot:text>
              Écrans de<br>
              diffusion
            </template>
          </SlideButton>
        </div> -->
        <div @click="editSettings">
          <SlideButton class="large-btn shadow editProg" v-bind:width="buttonBlockWidth" >
            <template v-slot:icon>
              mdi-calendar-month
            </template>
            <template v-slot:text>
              Modifier la<br>
              programmation
            </template>
          </SlideButton>
        </div>
<!--         <div>
          <SlideButton class="large-btn shadow replaceMedia" v-bind:width="buttonBlockWidth" >
            <template v-slot:icon>
              mdi-find-replace
            </template>
            <template v-slot:text>
              Remplacer<br>
              le média
            </template>
          </SlideButton>
        </div> -->
        <div @click="removeMedia">
          <SlideButton class="large-btn shadow deleteMedia" v-bind:width="buttonBlockWidth" >
            <template v-slot:icon>
              mdi-delete
            </template>
            <template v-slot:text>
              Supprimer<br>
              le média
            </template>
          </SlideButton>
        </div>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import SlideButton from './SlideButton'
import DBService from '@/services/DBService'

/* import FtpService from '@/services/FTPService'
 */
export default {
  props: ['content', 'screen'],
  data () {
    return {
      today: null,
      status: '',
      statusClass: '',
      buttonBlockWidth: '172px',
      media: null,
      d: null,
      f: null,
      loading: true,
      thumbnailPath: '',
      suspendable: false,
      statusIcon: '',
      editDisabled: true,
      screentype: ''
    }
  },
  components: {
    SlideButton
  },
  async created () {
    if (this.screen.fk_screen_type === 2 || this.screen.fk_screen_type === 4) {
      this.screentype = 'portrait'
    } 
    const serverPath = 'https://sandisplay.allsan.fr/players/' + this.$store.state.selectedSite.SitNom + '/PUB/'
    this.media = this.content
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    if (month < 10) {
      month = '0' + month.toString()
    }
    var day = date.getDate()
    if (day < 10) {
      day = '0' + day.toString()
    }
    this.statusClass = this.media.statusClass
    this.status = this.media.status
    this.suspendable = this.media.suspendable
    this.statusIcon = this.media.statusIcon
    this.today = year.toString() + month.toString() + day.toString()
    if (!this.media.isOldFile) {
      this.d = this.media.date_debut.substring(0,4).toString() + this.media.date_debut.substring(5,7).toString() + this.media.date_debut.substring(8).toString()
      this.f = this.media.date_fin ? this.media.date_fin.substring(0,4).toString() + this.media.date_fin.substring(5,7).toString() + this.media.date_fin.substring(8).toString() : null
  /*  if (parseInt(this.d, 10) > parseInt(this.today, 10)) {
      this.statusClass = 'programmed'
      this.status = this.screentype === 'portrait' ? '' : 'Programmé'
      this.suspendable = true
      this.statusIcon = 'mdi-calendar-check-outline'
    } else if (!this.media.suspendu){
      this.statusClass = 'suspended'
      this.status = this.screentype === 'portrait' ? '' : 'Suspendu'
      this.suspendable = true
      this.statusIcon = 'mdi-television-pause'
    } else if (parseInt(this.f, 10) >= parseInt(this.today, 10)) {
      this.statusClass = 'ongoing'
      this.status = this.screentype === 'portrait' ? '' : 'En diffusion'
      this.statusIcon = 'mdi-television-play'
    } else if (parseInt(this.f, 10) < parseInt(this.today, 10)) {
      this.statusClass = 'done'
      this.status = this.screentype === 'portrait' ? '' : 'Terminé'
      this.statusIcon = 'mdi-calendar-remove-outline'
    } else {
      this.statusClass = 'ongoing'
      this.status = this.screentype === 'portrait' ? '' : 'En diffusion'
      this.statusIcon = 'mdi-television-pause'
    } */

      if (this.media.miniature){     
        if (this.screen.server_name !== 'Ligne de caisse') {
          this.thumbnailPath = serverPath + this.screen.server_name + '/' + this.media.miniature
        } else {
          if (this.media.media_name.endsWith('avi') || this.media.media_name.endsWith('mp4')) {
            this.thumbnailPath = serverPath + this.media.miniature
          } else {
            this.thumbnailPath = serverPath + 'transition_local' + this.media.transition_local + '/' + this.media.media_name
          }
        }
      } else {
        if (!this.media.transition_local){
          this.thumbnailPath = serverPath + this.screen.server_name + '/bloc_pub1/' + this.media.media_name
        } else {
          this.thumbnailPath = serverPath + 'transition_local' + this.media.transition_local + '/' + this.media.media_name
        }
      }

     /*  if (this.media.miniature){
        this.thumbnailPath = serverPath + this.screen.server_name + '/' + this.media.miniature
        
      } else {
        if (!this.media.transition_local){
          this.thumbnailPath = serverPath + this.screen.server_name + '/bloc_pub1/' + this.media.media_name
        } else {
          this.thumbnailPath = serverPath + 'transition_local' + this.media.transition_local + '/' + this.media.media_name
        }
      } */
    } else {
      if (this.media[0].path.endsWith('.mp4')) {
        var folders = this.media[0].path.split('/')
        var videoThumbnail = this.media[0].name.substring(9,22)
        var videoPath = this.media[0].path.substring(0, this.media[0].path.lastIndexOf('/'))
        this.thumbnailPath = serverPath + folders[3] + '/' + videoThumbnail + '.jpg'
      } else {
        this.thumbnailPath = 'https://sandisplay.allsan.fr/players' + this.media[0].path
      }   
      if (this.media.id.includes('__d')) {
        var _d = this.media.id.split('__d')[1]
        this.d = _d.substring(0,4).toString() + _d.substring(4,6).toString() + _d.substring(6,8).toString()
      } else {
        this.d = null
      }
      if (this.media.id.includes('__f')){
        var _f = this.media.id.split('__f')[1]
        this.f = _f.substring(0,4).toString() + _f.substring(4,6).toString() +_f.substring(6,8).toString()
      } else {
        this.f = null
      }
    }
  },
  methods: {
    displayMedia: function () {
      this.loading = false
    },
    suspendMedia () {
      this.$parent.$parent.$parent.showSuspendMediaModal(this.media)
    },
    editSettings () {
      this.$parent.$parent.$parent.editSettings(this.media)
    },
    async removeMedia () {
      this.$parent.$parent.$parent.confirmRemove(this.media)
    },
    editMedia () {
      this.$store.dispatch('setMediaToEdit', this.media)
      this.$parent.$parent.$parent.editMedia()
    },
    startBroadcast () {
      this.$parent.$parent.$parent.startMediaBroadcast(this.media)
    },
    changeOrder (up) {
      this.$parent.$parent.$parent.changeOrder(this.media, up)
    }
  },
  computed: {
    broadcastDates: function () {
      if (this.d && this.f) {
        return 'Début de diffusion : <b>' + this.d.substring(6) + '/' + this.d.substring(4, 6) + '/' + this.d.substring(0, 4) + '</b>' +
          '<br > Fin de diffusion : <b>' + this.f.substring(6) + '/' + this.f.substring(4, 6) + '/' + this.f.substring(0, 4) + '</b>'
        //  return 'Diffusion du <b>' + this.file.start.substring(6) + '/' + this.file.start.substring(4, 6) + '/' + this.file.start.substring(0, 4) + '</b> au <b>' + this.file.end.substring(6) + '/' + this.file.end.substring(4, 6) + '/' + this.file.end.substring(0, 4) + '</b>'
      } else if (this.d && !this.f) {
        if (parseInt(this.d, 10) > parseInt(this.today, 10)) {
          return 'Diffusion à partir du <b>' + this.d.substring(6) + '/' + this.d.substring(4, 6) + '/' + this.d.substring(0, 4) + '</b>'
        } else {
          return 'Diffusion depuis le <b>' + this.d.substring(6) + '/' + this.d.substring(4, 6) + '/' + this.d.substring(0, 4) + '</b>'
        }
      } else if (!this.d && this.f) {
        return 'Diffusion jusqu\'au <b>' + this.f.substring(6) + '/' + this.f.substring(4, 6) + '/' + this.f.substring(0, 4) + '</b>'
      } else {
        return 'Diffusion continue'
      }
    },
    broadcastHours: function () {
      if (this.media.isOldFile) {
        if (this.media.id.includes('__hf') || this.media.id.includes('__hd')) {
          if (this.media.id.includes('__hd') && !this.media.id.includes('__hd')) {
            var _hd = this.media.id.split('__hd')[1]
            _hd = _hd.substring(0, 4)
            return 'À partir de : <b>' + _hd.substring(0, 2) + ':' + _hd.substring(2) + '</b>'
          } else if (!this.media.id.includes('__hd') && this.media.id.includes('__hd')) {
            var _hf = this.media.id.split('__hf')[1]
            _hf = _hf.substring(0, 4)
            return 'Jusqu\'à : <b>' + _hf.substring(0, 2) + ':' + _hf.substring(2) + '</b>'
          } else {
            var _hd = this.media.id.split('__hd')[1]
            _hd = _hd.substring(0, 4)
            var _hf = this.media.id.split('__hf')[1]
            _hf = _hf.substring(0, 4)
            return 'Plage horaire : <b>' + _hd.substring(0, 2) + ':' + _hd.substring(2) + '</b>' + ' - <b>' + _hf.substring(0, 2) + ':' + _hf.substring(2) + '</b>'
          }
        } else {
          return 'À toute heure'
        }
      } else {
        if (this.media.heure_debut && this.media.heure_fin) {
          return 'Plage horaire : <b>' + this.media.heure_debut.substring(0, 2) + ':' + this.media.heure_debut.substring(2) + '</b>' + ' - <b>' + this.media.heure_fin.substring(0, 2) + ':' + this.media.heure_fin.substring(2) + '</b>'
        } else {
          return 'À toute heure'
        }
      }
    },
    broadcastDuration: function () {
      if (this.media.isOldFile) {
        if (this.media.id.endsWith('.mp4')) {
          return ''
        } else {
          if (this.media.id.includes('__tpf')) {
            var tpf = this.media.id.split('__tpf')[1]
            if (tpf.includes('_')) {
              tpf = tpf.substring(0, tpf.indexOf('_'))
              return 'durée : ' + '<b>' + tpf + '"' + '</b>'
            } else {
              tpf = tpf.substring(0, tpf.indexOf('.'))
              return 'durée : ' + '<b>' + tpf + '"' + '</b>'
            }
          } else {
            return 'durée : <b>10"</b>'
          }
        }
      } else {
        return 'durée : ' + '<b>' + this.media.duree_diffusion + '"' + '</b>'
      }
    },
    broadcastScreens: function () {
      var returnString = ''
      if (!this.media.isOldFile) {
        var stmp = this.media.ecrans
        var screens = stmp.split(',')
        screens.forEach(element => {
          returnString += element + ', '
        })
        returnString = returnString.substring(0, returnString.length-2)
      } else {
        var returnString = ''
        for (let i = 0 ; i < this.media.length; i++) {
          var folders = this.media[0].path.split('/')
          returnString += folders[3] + ', '
        }
        returnString = returnString.substring(0, returnString.length-2)
      }
    
      return this.media ? returnString : ''
    },
    broadcastDays: function () {
      var returnValue = ''
      if (this.media.isOldFile) {
        if (this.media.id.includes('__jd')) {
          if (daysArray.includes('L')) {
              returnValue += this.$i18n.t('global.days.1').substring(0,3) + '. '
            }
            if (daysArray.includes('A')) {
              returnValue += this.$i18n.t('global.days.2').substring(0,3) + '. '
            }
            if (daysArray.includes('R')) {
              returnValue += this.$i18n.t('global.days.3').substring(0,3) + '. '
            }
            if (daysArray.includes('J')) {
              returnValue += this.$i18n.t('global.days.4').substring(0,3) + '. '
            }
            if (daysArray.includes('V')) {
              returnValue += this.$i18n.t('global.days.5').substring(0,3) + '. '
            }
            if (daysArray.includes('S')) {
              returnValue += this.$i18n.t('global.days.6').substring(0,3) + '. '
            }
            if (daysArray.includes('D')) {
              returnValue += this.$i18n.t('global.days.7').substring(0,3) + '. '
            }
            returnValue = returnValue.substring(0, returnValue.length - 1)
        } else {
          return this.$i18n.t('global.days.0')
        }
      } else {
        if (this.media) {
          var daysArray = this.media.jours_diffusion.split(',')
          if (daysArray.includes('0')) {
            return this.$i18n.t('global.days.0')
          } else {
            if (daysArray.includes('1')) {
              returnValue += this.$i18n.t('global.days.1').substring(0,3) + '. '
            }
            if (daysArray.includes('2')) {
              returnValue += this.$i18n.t('global.days.2').substring(0,3) + '. '
            }
            if (daysArray.includes('3')) {
              returnValue += this.$i18n.t('global.days.3').substring(0,3) + '. '
            }
            if (daysArray.includes('4')) {
              returnValue += this.$i18n.t('global.days.4').substring(0,3) + '. '
            }
            if (daysArray.includes('5')) {
              returnValue += this.$i18n.t('global.days.5').substring(0,3) + '. '
            }
            if (daysArray.includes('6')) {
              returnValue += this.$i18n.t('global.days.6').substring(0,3) + '. '
            }
            if (daysArray.includes('7')) {
              returnValue += this.$i18n.t('global.days.7').substring(0,3) + '. '
            }
            returnValue = returnValue.substring(0, returnValue.length - 1)
          }
        }
      }   
      return returnValue
    }
  }
}
</script>

<style scoped>

.loading {
  background: rgba(0, 0, 0, 0.12)!important;
}

.loading::after{
  animation: loading 1.5s infinite;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  z-index: 1;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
}

</style>
